import { useState } from "react";
import { findItemById, getElements, getValueByPath } from "../utils";

// const initEditState = {
//   id: "",
//   type: "",
//   show: false,
//   device: "",
//   config: null,
//   elements: null,
//   subType: "",
//   baseElement: null,
//   folderIds: [],
//   jobPlaces: ""
// };

const initialState = {
  type: "",
  show: false,
  heading: "",
  config: null
};

const useEditElement = ({ layoutConfig, setSelectedItem, buttonElements, onClick, device }) => {
  const [editElement, setEditElement] = useState(initialState);

  const closeEditBar = () => {
    setEditElement(initialState);
    // setSelectedItem(null);
  };

  const openEditBar = (selectedItem, otherInfo) => {
    let actualElement = selectedItem;
    let folderIds = [];
    let jobPlaces = "";
    if (otherInfo && otherInfo.path) {
      const element = findItemById(layoutConfig, otherInfo.path[0]);
      if (
        element.type === "element" &&
        element.config &&
        element.config.type === "field" &&
        element.config.field_type === "recordset-list"
      ) {
        folderIds = [element.config.id];
      }
      if (element.type === "element" && element.config && element.config.type === "rv_table") {
        jobPlaces = "records_view_row";
      }
      const data = getValueByPath(element, otherInfo.path[1]);
      actualElement = findItemById(data, selectedItem.id);
    } else {
      actualElement = findItemById(layoutConfig, selectedItem.id);
    }
    if (!actualElement) return;
    let { id, type, config, tabs } = actualElement;
    const isElement = type === "element";
    const isTab = type === "tab";
    let subType;
    type = isElement ? config.type : type;

    let newConfig = isTab ? tabs : config || {};
    if (isElement && type === "table" && !otherInfo) {
      closeEditBar();
      return;
    }
    if (config && config.type === "rv_table" && otherInfo) {
      if (otherInfo.type === "add_field_rich_column") {
        onClick(actualElement, otherInfo);
        return;
      }
      if (otherInfo.type === "edit_catalog") {
        onClick(actualElement, otherInfo);
        return;
      }
    }
    if (otherInfo && otherInfo.type === "edit_map_card") {
      onClick(actualElement, otherInfo);
      return;
    }

    if (isElement && type === "table" && otherInfo) {
      if (["edit_column_cell", "edit_row_cell"].includes(otherInfo.type)) {
        subType = otherInfo.type;
        newConfig = otherInfo.info.cell;
      }
      setSelectedItem(actualElement);
    }

    if (isElement && type === "rv_table" && otherInfo) {
      if (["edit_column"].includes(otherInfo.type)) {
        subType = otherInfo.type;
        newConfig = otherInfo.config;
      }
      setSelectedItem(actualElement);
    }
    const screenBlocks = ["recordsview", "detailsview", "kanban", "calendar", "mapsview", "pivotcharts"];
    const elementData = getElements(layoutConfig, screenBlocks);
    let elements = buttonElements || [];
    if (elementData && Array.isArray(elementData)) {
      elements = [...elements, ...elementData];
    }
    if (actualElement && onClick) {
      // if (otherInfo && selectedItem && onClick && type !== "table") {
      //   onClick(selectedItem, otherInfo);
      //   return;
      // }
      onClick(actualElement, otherInfo);
    }
    if (actualElement.type === "element" && screenBlocks.includes(actualElement.config.type)) {
      return;
    }
    if (actualElement.config && actualElement.config.type === "chart" && !actualElement.config.chart_type) {
      return;
    }
    setEditElement({
      type: "single_field",
      show: true,
      heading: type,
      config: {
        id,
        type,
        device: device || "desktop",
        config: newConfig,
        elements,
        baseElement: actualElement,
        subType,
        otherInfo,
        folderIds,
        jobPlaces
      }
    });
  };

  const openMultiFieldEditBar = (type, multiItems) => {
    setEditElement({
      type: "multi_field",
      show: true,
      heading: type,
      config: {
        items: multiItems,
        type
      }
    });
  };

  return {
    editElement,
    openEditBar,
    openMultiFieldEditBar,
    closeEditBar
  };
};

export default useEditElement;
